<template>
  <div
    class="control-cart"
    @mouseenter="showDropdownCart"
    @mouseleave="hideDropdownCart"
  >
    <div
      class="control-cart__wrap"
      @click="toCheckout"
    >
      <div class="icon">
        <f-sprite-icon :icon-link="$options.icons.IconCart" />
        <ui-badge
          :loading="UPDATE_PROGRESS"
          :text="PRODUCT_COUNT"
          max-width="50"
          use-animate-badge
        />
      </div>
      <div v-if="amount" class="control-cart__amount">
        <span>Сумма</span>
        <div
          class="price-rub"
          v-text="$filters.price(amount)"
        />
      </div>
    </div>

    <div class="dropdown">
      <ui-dropdown
        :visible="cartVisible"
        overlay-height="40"
        right
        :class="{ 'control-cart__dropdown-blocked-scroll': PRODUCTS.length <= 2 }"
      >
        <template v-if="PRODUCTS.length">
          <cart-item
            v-for="p in groupedProductsByQuantity"
            :key="p.lineIds[0]"
            :product="p"
            class="control-cart__cart-item"
          />
        </template>
        <template
          v-if="PRODUCTS.length"
          #footer
        >
          <div class="control-cart__checkout-btn">
            <ui-button wide text="Оформить заказ" @click="toCheckout" />
          </div>
          <banners-slot
            slot-name="header_basket"
            class="control-cart__banners-slot"
          />
        </template>
        <template v-if="!PRODUCTS.length">
          <page-info
            class="control-cart__empty"
            subtitle="В корзине пока нет<br>добавленных товаров"
          />
        </template>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Components */
import BannersSlot from '@/components/banners-slot/banners-slot.vue';

/* Icons */
import IconCart from '../../assets/icons/cart.svg';
import PageInfo from '../common/page-info.vue';

import CartItem from './cart-item/cart-item.vue';

export default {
  name: 'control-cart',
  components: {
    BannersSlot,
    CartItem,
    PageInfo,
  },

  inject: ['adaptive'],

  icons: {
    IconCart,
  },

  data: () => ({
    cartVisible: false,
  }),

  computed: {
    ...mapGetters({
      PRODUCT_COUNT: 'cart/productCount',
      SUBTOTAL: 'cart/subtotal',
      PRODUCTS: 'cart/products',
      UPDATE_PROGRESS: 'cart/updateProgress',
    }),

    groupedProductsByQuantity() {
      return this.PRODUCTS
        .reduce((acc, product) => {
          const currentProduct = acc.find(({ skuId }) => skuId === product.skuId);

          if (currentProduct) {
            currentProduct.quantity += product.quantity;
            return acc;
          }
          return [...acc, { ...product }];
        }, [])
        .sort((a, b) => new Date(b.addedOn).valueOf() - new Date(a.addedOn).valueOf());
    },

    amount() {
      return parseInt(this.SUBTOTAL);
    },
  },

  methods: {
    toCheckout() {
      location = '/checkout';
    },

    showDropdownCart() {
      if (this.adaptive.isDesktop) this.cartVisible = true;
    },

    hideDropdownCart() {
      if (this.adaptive.isDesktop) this.cartVisible = false;
    },
  },
};
</script>

<style lang="scss">
.control-cart {
  &__wrap {
    display: flex;
    flex-wrap: nowrap;
    cursor: pointer;
  }

  &__checkout-btn {
    padding: 0 12px;
    margin: 12px 0;

    .ui-button {
      border-radius: 4px;
    }
  }

  &__cart-item {
    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      box-shadow: none;
    }
  }

  &__banners-slot {
    padding: 0 12px 12px;
  }

  &__amount,
  &__dropdown {
    display: none;
  }

  &__empty {
    p {
      font-weight: 600;
    }
  }

  .ui-dropdown-content {
    padding-top: 12px;
  }
}

@include breakpoint("desktop") {
  .control-cart {
    &__amount {
      display: block;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      margin: -8px 0 -8px 20px;

      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        display: block;
        color: $gray;
      }
    }

    &__dropdown-blocked-scroll {
      .ui-dropdown-scrollview {
        overflow-y: hidden;
      }
    }

    .ui-dropdown {
      top: 40px;
      width: 360px;
    }

    .page-info {
      margin: 0;
      padding: 40px;
    }
  }
}

</style>
